import { Alert, AlertTitle, Collapse, IconButton } from "@mui/material";
import { Close, Error } from "@mui/icons-material";
import InfoIcon from "@mui/icons-material/Info";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useEffect } from "react";

interface AlertBarProps {
  severity: any;
  title?: any;
  description: any;
  isClose?: boolean;
  variant?: any;
  show?: boolean;
  setShow: any;
  isFixed?: boolean;
}
export default function AlertBar({ severity, title, description, isClose = true, variant = "filled", show, setShow, isFixed }: AlertBarProps) {
  const autoCloseMessages = ["Password successfully reset.", "You were logged out due to inactivity. ", "Password updated."];

  useEffect(() => {
    if (show && isClose && ((description && autoCloseMessages.includes(description)) || (title && autoCloseMessages.includes(title)))) {
      const timer = setTimeout(() => {
        setShow(false);
        clearTimeout(timer);
      }, 5000); // Auto close after 5 seconds

      return () => clearTimeout(timer);
    }
  }, [show, description, title]);

  return (
    <Collapse
      in={show}
      sx={{
        ...(isFixed && {
          // position: "fixed",
          // top: 121,
          // left: { xs: 0, sm: 240 }, // 240px for drawer on sm+, 0 on xs
          // right: 0,
          // width: { xs: "100%", sm: "calc(100% - 240px)" }, // Responsive width
          // maxWidth: "600px", // Prevents overflow on large screens
          // margin: "0 auto", // Center horizontally
          // padding: "0 16px",
          zIndex: 1200,
          display: "flex",
          justifyContent: "center",
          boxSizing: "border-box",
        }),
      }}
    >
      <Alert
        icon={severity === "error" ? <Error fontSize="inherit" /> : severity === "success" ? <CheckCircleIcon fontSize="inherit" /> : severity === "info" ? <InfoIcon fontSize="inherit" /> : undefined}
        sx={{
          pointerEvents: "auto",
        }}
        variant={variant}
        severity={severity}
        action={
          isClose && (
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setShow(false);
              }}
            >
              <Close fontSize="inherit" />
            </IconButton>
          )
        }
      >
        {title && <AlertTitle>{title}</AlertTitle>}
        {description}
      </Alert>
    </Collapse>
  );
}
